const message =  {
    matdatil: '详情',
    time:'举办时间',
    baoming:'报名时间',
    address: '举办地点',
    porpa: "详情介绍",
    serch: "报名查询",
    jion: "加入队伍",
    term: "使用团队码报名",
    go:"至"
  }
export default message;